export default "__VITE_ASSET__DwKAvwpJ__"